export const filterDataByDateRange = (
  data,
  startDateString,
  endDateString,
  withData
) => {
  const start = new Date(startDateString);
  start.setUTCHours(0, 0, 0, 0);
  const end = new Date(endDateString);
  end.setUTCHours(23, 59, 59, 999);

  const filteredInRange = Object.entries(data).reduce(
    (acc, [queueId, queueData]) => {
      acc[queueId] = {
        ...queueData,
        daily_stats: Object.entries(queueData.daily_stats || {}).reduce(
          (dailyAcc, [date, dayData]) => {
            const currentDate = new Date(date);
            if (
              currentDate.toISOString() >= start.toISOString() &&
              currentDate.toISOString() <= end.toISOString()
            ) {
              dailyAcc[date] = dayData;
            }
            return dailyAcc;
          },
          {}
        ),
      };
      return acc;
    },
    {}
  );

  if (withData) {
    return Object.entries(filteredInRange).reduce(
      (acc, [queueId, queueData]) => {
        if (Object.keys(queueData.daily_stats).length > 0) {
          acc[queueId] = queueData;
        }
        return acc;
      },
      {}
    );
  }
  return filteredInRange;
};
